import { render, staticRenderFns } from "./MobilePaginationBar.vue?vue&type=template&id=243930a6"
import script from "./MobilePaginationBar.vue?vue&type=script&lang=js"
export * from "./MobilePaginationBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports